import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * The live "Payments" nav destination (ClickUp 869f0ev24). This app has no
 * user search yet — that is the Users+Content sibling's build (support-admin
 * proposal §6 Phase 1), not landed on `dev` as of this task — so there is no
 * list of users to click into. Until that lands, an admin who already knows
 * the profile id (from a support ticket, from `/api/admin/users` today) can
 * jump straight to that user's payments screen. This page becomes a search
 * box once the Users list exists; it does not duplicate that build.
 */
export function PaymentsLookupPage() {
  const [profileId, setProfileId] = useState('');
  const navigate = useNavigate();

  function go() {
    const id = profileId.trim();
    if (!id) return;
    navigate(`/users/${id}/payments`);
  }

  return (
    <div>
      <h1 className="text-h2 font-semibold text-fg-primary">Payments</h1>
      <p className="mt-2 text-body text-fg-secondary">
        Open a user&apos;s payments by profile id. A search-by-email screen lands with the Users
        list (Phase 1).
      </p>
      <form
        className="mt-4 flex max-w-md gap-2"
        onSubmit={(e) => {
          e.preventDefault();
          go();
        }}
      >
        <label className="sr-only" htmlFor="profile-id-input">
          Profile id
        </label>
        <input
          id="profile-id-input"
          className="flex-1 rounded-card border border-border bg-surface-field px-3 py-2 text-body text-fg-primary"
          placeholder="Profile id (uuid)"
          value={profileId}
          onChange={(e) => setProfileId(e.target.value)}
        />
        <button
          type="submit"
          className="rounded-card bg-primary px-4 py-2 text-body font-medium text-primary-foreground hover:bg-primary-hover disabled:opacity-50"
          disabled={!profileId.trim()}
        >
          Open
        </button>
      </form>
    </div>
  );
}
